import { PREMIUM_FEATURE_NAMES } from '../../../constants';

import shiftAlarmsUrl from './shiftAlarmsComponent.html';

const SHIFT_ALARMS_LIMIT = 3;

class ShiftAlarmsCtrl {
  alarmsModel = [];
  MULTIPLE_ALARMS_FEATURE_NAME = PREMIUM_FEATURE_NAMES.multipleAlarms;

  constructor(Authentication, sdk) {
    'ngInject';

    const { DURATION_UNIT_OPTIONS, HOURS_OPTION_VALUE, MINUTES_OPTION_VALUE } = sdk('constants');
    Object.assign(this, {
      Authentication,
      DURATION_UNIT_OPTIONS,
      HOURS_OPTION_VALUE,
      MINUTES_OPTION_VALUE,
    });

    this.getInitialModel = sdk('helpers/shiftAlarms/getInitialModel');
  }

  $onInit() {
    this.DEFAULT_UNIT = this.DURATION_UNIT_OPTIONS.find(
      (option) => option.value === this.MINUTES_OPTION_VALUE
    );
    this.areMultipleAlarmsEnabled = this.Authentication.isOrgFeatureEnabled(
      this.MULTIPLE_ALARMS_FEATURE_NAME
    );
    this.resetAlarmsForm();
    this.unregisterReset = this.registerFormResetListener({
      callback: () => this.resetAlarmsForm(),
    });
    this.unregisterSubmit = this.registerFormSubmitListener({
      callback: () => this.submitAlarms(),
    });
  }

  $onDestroy() {
    this.unregisterReset?.();
    this.unregisterSubmit?.();
  }

  getDefaultAlarm() {
    return {
      value: null,
      unit: { ...this.DEFAULT_UNIT },
    };
  }

  canAddAnotherAlarm() {
    return this.alarmsModel.length < SHIFT_ALARMS_LIMIT;
  }

  addAnotherAlarm() {
    this.alarmsModel.push(this.getDefaultAlarm());
  }

  removeAlarm(alarm) {
    this.alarmsModel = this.alarmsModel.filter((a) => a !== alarm);
    this.form?.$setDirty();
  }

  resetAlarmsForm() {
    this.alarmsModel = this.getInitialModel(this.userSettings, this.areMultipleAlarmsEnabled);
    this.resetAlarmsChecklist();
  }

  resetAlarmsChecklist() {
    this.alarmsChecklist = [];
    if (this.userSettings.shiftAlarmNotifyViaPush) {
      this.alarmsChecklist.push('push');
    }
    if (this.userSettings.shiftAlarmNotifyViaSms) {
      this.alarmsChecklist.push('sms');
    }
    if (this.userSettings.shiftAlarmNotifyViaEmail) {
      this.alarmsChecklist.push('email');
    }
  }

  submitAlarms() {
    delete this.userSettings.clientFlags.shiftAlarmTimeBeforeInHours;
    delete this.userSettings.shiftAlarmMinutesBefore;
    const sortedAlarms = this.alarmsModel.sort((a, b) => a.value - b.value);

    this.userSettings.shiftAlarms = sortedAlarms.map((alarm) => alarm.value);
    this.userSettings.clientFlags.shiftAlarmsUnits = sortedAlarms.map((alarm) => alarm.unit.value);
  }
}

export default {
  templateUrl: shiftAlarmsUrl,
  controller: ShiftAlarmsCtrl,
  controllerAs: 'ctrl',
  bindings: {
    userSettings: '<',
    alarmsChecklist: '=',
    registerFormResetListener: '&',
    registerFormSubmitListener: '&',
  },
};
